import React from 'react'
import CardUI from '../../widgets/layout/CardUI'
import FormSF from '../../widgets/form/FormSF'
import MessageUI from '../../widgets/output/MessageUI'
import InputTextSF from '../../widgets/form/InputTextSF'

const LinkSocialUserUI = ({context, messageList, onSubmit, submitted, successMsg, errorList, setErrorList, provider,
    password, onPasswordChange, passwordError, setPasswordError
  }) =>
  <CardUI context={context}>
    <FormSF context={context} messageList={messageList} buttonMessageKey='c_submit'
        onSubmit={onSubmit} successMsg={successMsg} errorList={errorList} setErrorList={setErrorList}
        busy={submitted}>
      <MessageUI
        messageList={messageList}
        messageKey='c_soc_link_account'
        args={[context.session.appName, provider, context.session.appName, context.session.appName, context.session.appName]}
      />
      <InputTextSF type='password' name='password' required={true} maxLength={40}
        messageList={messageList} labelKey='c_password'
        value={password} onChange={onPasswordChange}
        error={passwordError} setError={setPasswordError}
        autoFocus={true}
      />
    </FormSF>
  </CardUI>

export default LinkSocialUserUI
